import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "User",
  "use": "User-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"User\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 0C7.168 0 0 7.168 0 16s7.168 16 16 16 16-7.168 16-16S24.832 0 16 0Zm0 4.8c2.656 0 4.8 2.144 4.8 4.8 0 2.656-2.144 4.8-4.8 4.8a4.794 4.794 0 0 1-4.8-4.8c0-2.656 2.144-4.8 4.8-4.8ZM6.4 22.368A11.52 11.52 0 0 0 16 27.52c4 0 7.536-2.048 9.6-5.152-.048-3.184-6.416-4.928-9.6-4.928-3.2 0-9.552 1.744-9.6 4.928Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol